<template>
  <div id="PartSearchFacetsExpand" class="part-search-facet-expand__container">
    <div>
      <b-row class="no-gutters">
        <b-col 
          v-if="facet.length > 0"
          :aria-expanded="isTitleCollapsed"
          :aria-controls="'facet'+facetKey"
          :class="['nav-sub__sub-header', 'psfe__facet-title',
            {'collapsed': isTitleCollapsed, 
            'col-sm-9': isTms,
            'col-sm-12': !isTms
            }
          ]"
          @click="toggleTitle()"
        >
          <b-col sm="12" role="tab" class="px-1">
            <h6>
              <fa-icon :icon="isTitleCollapsed ? 'angle-up' : 'angle-down'" class="mt-1 pt-1" />&nbsp;{{ replace_(facetKey) }}&nbsp;({{ facet.length }})
            </h6>
          </b-col>
        </b-col>
        <b-col v-if="isTms" sm="3" class="nav-sub__sub-header" >
          <part-search-facet-extras
            v-if="isTms && hasCommonParts"
            :facet="facet" 
            :facet-key="facetKey"
            class="pr-1"
            @add-facet="addFacet"
          />
        </b-col>
      </b-row>
      <b-collapse 
        :id="'facet'+facetKey"
        v-model="isTitleCollapsed"
        role="tabpanel"
      >
        <div v-if="facet.length <= 10">  
          <div v-for="(item, itemKey) in facet" :key="itemKey">
            <ul class="p-0">
              <li>
                <span class="part-search-facet" @click="addFacet(facetKey,item.Key)">
                  {{ item.Key }}&nbsp;({{ item.Value }})
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>  
          <div v-for="(item, itemKey) in facetsFirstTen" :key="itemKey">
            <ul class="p-0">
              <li>
                <span class="part-search-facet" @click="addFacet(facetKey,item.Key)">
                  {{ item.Key }}&nbsp;({{ item.Value }})
                </span>
              </li>
            </ul>
          </div>
          <div class="psfe__facet-title">
            <b-collapse id="facets_the-rest" v-model="isFacetCollapsed" sm="12">
              <div v-for="(item, itemKey) in facetsTheRest" :key="itemKey">
                <ul class="p-0">
                  <li>
                    <span class="part-search-facet" @click="addFacet(facetKey,item.Key)">
                      {{ item.Key }}&nbsp;({{ item.Value }})
                    </span>
                  </li>
                </ul>
              </div>
            </b-collapse>
            <b-col 
              sm="12" 
              class="psfe__facet-show-more-less pt-1"
              :class="isFacetCollapsed ? null : 'collapsed'"
              :aria-expanded="isFacetCollapsed"
              aria-controls="facets_the-rest"
              @click="isFacetCollapsed = !isFacetCollapsed"
            >
              <fa-icon :icon="isFacetCollapsed ? 'angle-up' : 'angle-down'" class="mt-1" />&nbsp;{{ ShowMoreLess }}
            </b-col>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  import { mapGetters }   from "vuex"
  import { constants }    from "@/const"
  import { stringHelper } from "@/components/mixins/stringHelper"
  import PartSearchFacetExtras from "@/components/PartDiagramSearch/PartSearchFacetExtras/PartSearchFacetExtras.vue"

  export default {
    name: "PartSearchFacetsExpand",
    components: {
      PartSearchFacetExtras
    },
    mixins: [
      stringHelper
    ],
    props: {
      facet: { type: Array, default: () => [] },
      facetKey: { type: String, default: "" },
      isTms: { type: Boolean, default: false },
      hasCommonParts: { type: Boolean, default: false }
    },
    data: () => ({
      pageSize: constants.CATEGORY_FACET_PAGE_SIZE,
      startFacet: 0,
      endFacet: 10,
      currentPage: 1,
      isTitleCollapsed: true,
      isFacetCollapsed: false,
    }),
    computed: {
      ...mapGetters(["getContentItem"]),
      NumberOfResults() {
        return this.facet.length;
      },
      ShowMoreLess() {
        return this.isFacetCollapsed ? "Show Less" : "Show More";
      },
      facetsFirstTen() {
        if(this.facet.length > 9) {
          return this.facet.slice(0,10);
        }
        return [];
      },
      facetsTheRest(){
        if(this.facet.length > 9){
          return this.facet.slice(10, this.facet.length);
        }
        return []
      }
    },
    methods: {
      toggleTitle() {
        // we always want the internal facet values to be minimized, this will do that.
        this.isFacetCollapsed = false;
        //set the title boolean
        this.isTitleCollapsed = !this.isTitleCollapsed;
      },
      addFacet(key,value) {
        if( key !== undefined){
          this.$emit("add-facet",key,value);
        }        
      },
    }
  }
</script>

<style lang="scss">
// psfe stands for "part-search-facet-expand__" 
.psfe__facet-title {  
  cursor: pointer;
}
.psfe__facet-show-more-less {
  font-size: 1.1em;
  text-emphasis: bold;
  color: rgb(23, 96, 156);
}
</style>
